import newComparisonActive from "../../static/pic/newComparisonActive.svg"
import newComparisonBlur from "../../static/pic/newComparisonBlur.svg"
import Upload from "../upload/upload"
import Attachment from "../attachment/oldAttachment"
import historicalComparisonActive from "../../static/pic/historicalComparisonActive.svg"
import historicalComparisonBlur from "../../static/pic/historicalComparisonBlur.svg"
import React from "react"
import Style from "./util.less"
import Table from "../common/table"
import {NavInfoRenderData} from "../operate/interface"
import {AttachmentItem, HistoricalDataItem} from "../../reducer/interface/dataInterface"
import {isValidKey} from "../upload/tips/uploadTips"

export const promiseType = {
    pdf: true,
    jpg: true,
    jpeg: true,
    png: true,
    bmp: true,
    tif: false,
    tiff: false,
    doc: true,
    docx: true,
    ofd: true,
}

export const VIEWTYPE = {
    TEST: "tda_test_task",
    CREATE: "tda_create_task",
    HISTORY: "taskhistoryview",
    SHOW: "tda_show_task",
}

let timer: any = null
export const debounce = (fn: any, time: any) => {
    return function () {
        if (timer) {
            timer = null
        } else {
            timer = setTimeout(fn, time)
        }
    }
}

export const NAVIGATIONINFO = [
    {
        title: "新建比对",
        id: "tda_create_task",
        selected: true,
        isShow: true,
        activeImg: newComparisonActive,
        blurImg: newComparisonBlur,
        render: () => {
            return [<Upload key={"newComparisonArea"} />, <Attachment key={"attachment"} />]
        },
    },
    {
        title: "历史比对",
        id: "taskhistoryview",
        selected: false,
        isShow: true,
        activeImg: historicalComparisonActive,
        blurImg: historicalComparisonBlur,
        render: (props: NavInfoRenderData) => {
            const colunm = HISTROICALDATA.COLUMN.concat([
                {
                    key: "operate",
                    isShow: true,
                    title: "操作",
                    froze: true,
                    style: {minWidth: 120, maxWidth: 120, justifyContent: "flex-start"},
                    render: (data) => {
                        return (
                            <div key={`petitioner${data.id}`} className={Style.formOperating}>
                                <span
                                    onClick={() => {
                                        props.history.getHistoricalDetail(data.id)
                                    }}
                                    className={Style.checkDetails}
                                >
                                    查看详情
                                </span>
                                <span
                                    onClick={() => {
                                        props.history.deleteHistoricalDetail(data.id)
                                    }}
                                    style={{marginLeft: 10}}
                                    className={Style.deleteDetail}
                                >
                                    刪除
                                </span>
                            </div>
                        )
                    },
                },
            ])
            return [
                <Table
                    key={"historicalComparison"}
                    column={colunm}
                    dataSource={props.history.dataSource}
                    onSelect={props.history.handleSelect}
                    selectItem={props.history.selectItem}
                />,
            ]
        },
    },
    {
        title: "展示比对",
        id: "tda_show_task",
        selected: false,
        isShow: false,
        activeImg: newComparisonActive,
        blurImg: newComparisonActive,
        render: () => {
            return [<Upload key={"showComparisonArea"} />]
        },
    },
    {
        title: "测试比对",
        id: "tda_test_task",
        selected: false,
        isShow: false,
        activeImg: newComparisonActive,
        blurImg: newComparisonActive,
        render: () => {
            return [<Upload key={"testComparisonArea"} />]
        },
    },
]

export const ATTACHMENTTABLEDATA = {
    COLUMN: [
        {
            key: "index",
            isShow: true,
            title: "序号",
            froze: false,
            style: {
                minWidth: 100,
                maxWidth: 100,
                justifyContent: "center",
            },
            render: function renderBlock(data: AttachmentItem) {
                return <span key={`index${data.id}`}>{data["index"]}</span>
            },
        },
        {
            key: "fileName",
            isShow: true,
            title: "附件名称",
            froze: false,
            style: {minWidth: 270, maxWidth: 270, justifyContent: "flex-start"},
            render: function renderBlock(data: AttachmentItem) {
                return <span key={`fileName${data.id}`}>{data["fileName"]}</span>
            },
        },
        {
            key: "userName",
            isShow: true,
            title: "上传人",
            froze: false,
            style: {minWidth: 270, maxWidth: 270, justifyContent: "flex-start"},
            render: function renderBlock(data: AttachmentItem) {
                return <span key={`userName${data.id}`}>{data["userName"]}</span>
            },
        },
        {
            key: "uploadTime",
            isShow: true,
            title: "上传时间",
            froze: false,
            style: {minWidth: 270, maxWidth: 270, justifyContent: "flex-start"},
            render: function renderBlock(data: AttachmentItem) {
                return <span key={`uploadTime${data.id}`}>{data["uploadTime"]}</span>
            },
        },
        {
            key: "url",
            isShow: false,
            title: "文件地址",
            froze: false,
            style: {minWidth: 270, maxWidth: 270, justifyContent: "flex-start"},
            render: function renderBlock(data: AttachmentItem) {
                return <span key={`url${data.id}`}>{data["url"]}</span>
            },
        },
        {
            key: "fileType",
            isShow: false,
            title: "文件类型",
            froze: false,
            style: {minWidth: 270, maxWidth: 270, justifyContent: "flex-start"},
            render: function renderBlock(data: AttachmentItem) {
                return <span key={`fileType${data.id}`}>{data["fileType"]}</span>
            },
        },
        {
            key: "fileSize",
            isShow: false,
            title: "文件大小",
            froze: false,
            style: {minWidth: 270, maxWidth: 270, justifyContent: "flex-start"},
            render: function renderBlock(data: AttachmentItem) {
                return <span key={`fileSize${data.id}`}>{data["fileSize"]}</span>
            },
        },
    ],
}

export const HISTROICALDATA = {
    COLUMN: [
        {
            key: "index",
            isShow: true,
            title: "序号",
            froze: false,
            style: {
                minWidth: 60,
                maxWidth: 60,
                justifyContent: "center",
            },
            render: function renderBlock(data: HistoricalDataItem) {
                return (
                    <span title={data["index"].toString()} key={`index${data.id}`}>
                        {data["index"]}
                    </span>
                )
            },
        },
        {
            key: "baseFileName",
            isShow: true,
            title: "原文档",
            froze: false,
            style: {
                minWidth: 150,
                maxWidth: 150,
                justifyContent: "flex-start",
            },
            render: function renderBlock(data: HistoricalDataItem) {
                return (
                    <span title={data["baseFileName"]} key={`baseFileName${data.id}`}>
                        {data["baseFileName"]}
                    </span>
                )
            },
        },
        {
            key: "compareFileName",
            isShow: true,
            title: "比对文档",
            froze: false,
            style: {minWidth: 150, maxWidth: 150, justifyContent: "flex-start"},
            render: function renderBlock(data: HistoricalDataItem) {
                return (
                    <span title={data["compareFileName"]} key={`compareFileName${data.id}`}>
                        {data["compareFileName"]}
                    </span>
                )
            },
        },
        {
            key: "creationDate",
            isShow: true,
            title: "创建时间",
            froze: false,
            style: {minWidth: 150, maxWidth: 150, justifyContent: "flex-start"},
            render: function renderBlock(data: HistoricalDataItem) {
                return (
                    <span title={toYMDHMS(data["creationDate"])} key={`creationDate${data.id}`}>
                        {toYMDHMS(data["creationDate"])}
                    </span>
                )
            },
        },
        {
            key: "endTime",
            isShow: true,
            title: "结束时间",
            froze: false,
            style: {minWidth: 150, maxWidth: 150, justifyContent: "flex-start"},
            render: function renderBlock(data: HistoricalDataItem) {
                return (
                    <span title={toYMDHMS(data["endTime"])} key={`endTime${data.id}`}>
                        {data["endTime"] === 0 ? "" : toYMDHMS(data["endTime"])}
                    </span>
                )
            },
        },
        {
            key: "status",
            isShow: true,
            title: "状态",
            froze: false,
            style: {minWidth: 100, maxWidth: 100, justifyContent: "flex-start"},
            render: function renderBlock(data: HistoricalDataItem) {
                const getHistoryStatusInfo = (status: string) => {
                    switch (status) {
                        case "success":
                            return {
                                style: {
                                    color: "#26B175",
                                },
                                title: "比对完成",
                            }
                        case "loading":
                            return {
                                style: {
                                    color: "#55A0F5",
                                },
                                title: "比对中",
                            }
                        case "running":
                            return {
                                style: {
                                    color: "#55A0F5",
                                },
                                title: "比对中",
                            }
                        case "error":
                            return {
                                style: {
                                    color: "#FB2323",
                                },
                                title: "比对失败",
                            }
                        default:
                    }
                }
                return (
                    <span key={`status${data.id}`} style={getHistoryStatusInfo(data.status)?.style}>
                        {getHistoryStatusInfo(data.status)?.title}
                    </span>
                )
            },
        },
        {
            key: "differencesNum",
            isShow: true,
            title: "差异总数",
            froze: false,
            style: {minWidth: 100, maxWidth: 100, justifyContent: "flex-start"},
            render: function renderBlock(data: HistoricalDataItem) {
                return (
                    <span title={data["differencesNum"].toString()} key={`differencesNum${data.id}`}>
                        {data["differencesNum"]}
                    </span>
                )
            },
        },
        {
            key: "creator",
            isShow: true,
            title: "申请人",
            froze: false,
            style: {minWidth: 100, maxWidth: 100, justifyContent: "flex-start"},
            render: function renderBlock(data: HistoricalDataItem) {
                return (
                    <span title={data["creator"]} key={`creator${data.id}`}>
                        {data["creator"]}
                    </span>
                )
            },
        },
    ],
}
const toYMDHMS = (inputTime: number) => {
    let date = new Date(inputTime)
    let y = date.getFullYear()
    let m: string | number = date.getMonth() + 1
    m = m < 10 ? `0${m}` : m
    let d: string | number = date.getDate()
    d = d < 10 ? `0${d}` : d
    let h: string | number = date.getHours()
    h = h < 10 ? `0${h}` : h
    let minute: string | number = date.getMinutes()
    let second: string | number = date.getSeconds()
    minute = minute < 10 ? `0${minute}` : minute
    second = second < 10 ? `0${second}` : second
    return `${y}-${m}-${d} ${h}:${minute}:${second}`
}
